<template>
    <a-layout-content class="overflow-hidden">
        <div class="filter-panel">
            <a-row>
                <a-col :span="24" class="other-filter">
                    <div class="mr-20">关键字:</div>
                    <a-input class="mr-20" placeholder="关键字" style="width: 220px" v-model="keyword" @keyup.enter="getList(true)" />
                    <div class="mr-20">物料名称:</div>
                    <a-select class="mr-20" style="width: 200px" v-model="materialName" placeholder="物料名称">
                        <a-select-option v-for="o in materials" :value="o" :key="o">{{ o }}</a-select-option>
                    </a-select>

                    <div class="mr-20">检测机构:</div>
                    <a-select class="mr-20" style="width: 80px" v-model="deptId" placeholder="检测机构">
                        <a-select-option v-for="o in depts" :value="o.deptId" :key="o.deptId">{{ o.deptName }}</a-select-option>
                    </a-select>

                    <div v-if="selectTab == 12" class="mr-20">操作时间:</div>
                    <span v-if="selectTab == 12">
                        <a-range-picker class="mr-20" :showTime="{
                            hideDisabledOptions: true,
                            defaultValue: [
                                moment('00:00:00', 'HH:mm:ss'),
                                moment('23:59:59', 'HH:mm:ss'),
                            ],
                        }" format="YYYY-MM-DD" @change="MonthOnChange" :value="createValue" />
                    </span>
                    <a-button class="mr-20 view-btn large" html-type="submit" @click="getList(true)">搜索</a-button>
                    <a-button class="mr-20 view-btn large" html-type="submit" @click="reset">重置</a-button>
                </a-col>
            </a-row>
        </div>
        <a-divider></a-divider>
        <div class="flex-container filter-panel filter-panel2">
            <sub-title>数据列表</sub-title>
            <ul class="handle-list" style="margin: -11px 0">
                <li class="handle-item" @click="expandAll">
                    <span v-if="this.expandedRowKeys.length == 0">
                        <a-icon type="plus-square" theme="twoTone" two-tone-color="#52c41a" />
                    </span>
                    <span v-else>
                        <a-icon type="minus-square" theme="twoTone" two-tone-color="#52c41a" />
                    </span>&nbsp;
                    <a href="javascript:;">{{ this.expandedRowKeys.length == 0 ? "展开" : "收起" }}</a>
                </li>
                <li class="handle-item" @click="checkMe(1)">
                    <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" />&nbsp;
                    <a href="javascript:;">抽检</a>
                </li>
                <li class="handle-item" @click="checkMe(2)">
                    <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" />&nbsp;
                    <a href="javascript:;">覆盖</a>
                </li>
                <li class="handle-item" @click="exportData">
                    <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" />&nbsp;
                    <a href="javascript:;">导出</a>
                </li>
                <li v-if="user.role == 1" class="handle-item" @click="checkMe(0)">
                    <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" />&nbsp;
                    <a href="javascript:;">恢复</a>
                </li>
            </ul>
        </div>
        <a-divider></a-divider>
        <div class="div-inline">
            <div>
                <a-tabs default-active-key="0" @change="callback" tab-position="top">
                    <a-tab-pane key="0" :tab="tabTitle1">
                        <a-table :columns="columns" :dataSource="list" :rowKey="(record) => record.b_id"
                            :loading="loading" :scroll="{ x: 1500, y: 800 }"
                            v-if="list && list.length >= 0 && selectTab == '0'" :pagination="pagination"
                            @change="onPageChange"
                            :row-selection="{ type: 'checkbox', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                            :expandedRowKeys.sync="expandedRowKeys" :rowClassName="rowClass" @expand="expandMe">
                            <div slot="filterDropdown"
                                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                style="padding: 8px;background: rgba(0, 0, 0, 0.65);">
                                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.title}`"
                                    :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.rcolumn)" />
                                <a-button type="primary" icon="search" size="small"
                                    style="width: 90px; margin-right: 8px; padding:0 7px;font-size: 14px;border-radius: 4px;height: 24px;"
                                    @click="() => handleSearch(selectedKeys, confirm, column.rcolumn)">
                                    Search
                                </a-button>
                                <a-button size="small" style="width: 90px; padding:0 7px;font-size: 14px;border-radius: 4px;height: 24px;" @click="() => handleReset(clearFilters,column.rcolumn)">
                                    Reset
                                </a-button>
                            </div>
                            <a-icon slot="filterIcon" slot-scope="filtered" type="search"
                                :style="{ color: filtered ? '#108ee9' : undefined }" />
                            <template slot="showTitle" slot-scope="text, record, index, column" ellipsis="...">
                                <div :title="text" style="white-space: pre-wrap;">{{ text }}</div>
                            </template>

                            <template slot="showTitle2" slot-scope="text, record" ellipsis="...">
                                <div :title="text" style="white-space: pre-wrap;" @click="searchMe(text)">{{ text }}</div>
                            </template>

                            <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                            <table width="95%">
                                <tr :class="rowClass(record)">
                                    <td width="23%">
                                        <span class="childCss">计划发（到）货时间：</span>
                                        <strong>
                                            {{ moment(record.b_plan_start).format("YYYY-MM-DD") }}
                                            ~{{ moment(record.b_plan_end).format("YYYY-MM-DD") }}
                                        </strong>
                                    </td>
                                    <td width="7%">
                                        <span class="childCss">数量：</span><strong>{{ record.b_num }}</strong>
                                    </td>
                                    <td width="25%">
                                        <span class="childCss">地点：</span><strong>{{ record.b_address }}</strong>
                                    </td>
                                    <td width="9%">
                                        <span class="childCss">联系人：</span><strong>{{ record.b_linkman }}</strong>
                                    </td>
                                    <td width="14%">
                                        <span class="childCss">联系电话：</span><strong>{{ record.b_linkphone }}</strong>
                                    </td>
                                    <td>
                                        <span class="childCss">备注说明：</span><strong>{{ record.b_remark }}</strong>
                                    </td>
                                    <td>
                                        <!-- <template slot="operation" slot-scope="text, record"> -->
                                        <a @click="checkOne(1, record.b_id)" href="javascript:;">抽检</a> |
                                        <a @click="checkOne(2, record.b_id)" href="javascript:;">覆盖</a>
                                        <span v-if="user.role == 1 || user.id == 9983 || user.id == 10028">
                                            |<a @click="checkOne(0, record.b_id)" href="javascript:;">恢复</a>
                                        </span>
                                        <!-- </template> -->
                                    </td>
                                </tr>
                            </table>
                            </p>

                            <template slot="showStatus" slot-scope="text, record">
                                <div :title="text">{{ getStatus(record.b_status) }}</div>
                            </template>
                        </a-table>

                    </a-tab-pane>
                    <a-tab-pane key="12" :tab="tabTitle2">
                        <a-table :columns="columns2" :dataSource="list" :rowKey="(record) => record.b_id"
                            :loading="loading" :scroll="{ x: 1500, y: 800 }"
                            v-if="list && list.length >= 0 && selectTab == '12'" :pagination="pagination"
                            @change="onPageChange"
                            :row-selection="{ type: 'checkbox', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                            :expandedRowKeys.sync="expandedRowKeys" :rowClassName="rowClass" @expand="expandMe">
                            <div slot="filterDropdown"
                                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                style="padding: 8px;background: rgba(0, 0, 0, 0.65);">
                                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.title}`"
                                    :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.rcolumn)" />
                                <a-button type="primary" icon="search" size="small"
                                    style="width: 90px; margin-right: 8px; padding:0 7px;font-size: 14px;border-radius: 4px;height: 24px;"
                                    @click="() => handleSearch(selectedKeys, confirm, column.rcolumn)">
                                    Search
                                </a-button>
                                <a-button size="small" style="width: 90px; padding:0 7px;font-size: 14px;border-radius: 4px;height: 24px;" @click="() => handleReset(clearFilters,column.rcolumn)">
                                    Reset
                                </a-button>
                            </div>
                            <a-icon slot="filterIcon" slot-scope="filtered" type="search"
                                :style="{ color: filtered ? '#108ee9' : undefined }" />
                            <template slot="showTitle" slot-scope="text, record" ellipsis="...">
                                <div :title="text" style="white-space: pre-wrap;">{{ text }}</div>
                            </template>

                            <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                            <table width="95%">
                                <tr :class="rowClass(record)">
                                    <td width="23%">
                                        <span class="childCss">计划发（到）货时间：</span>
                                        <strong>
                                            {{ moment(record.b_plan_start).format("YYYY-MM-DD") }}
                                            ~{{ moment(record.b_plan_end).format("YYYY-MM-DD") }}
                                        </strong>
                                    </td>
                                    <td width="7%">
                                        <span class="childCss">数量：</span><strong>{{ record.b_num }}</strong>
                                    </td>
                                    <td width="25%">
                                        <span class="childCss">地点：</span><strong>{{ record.b_address }}</strong>
                                    </td>
                                    <td width="9%">
                                        <span class="childCss">联系人：</span><strong>{{ record.b_linkman }}</strong>
                                    </td>
                                    <td width="14%">
                                        <span class="childCss">联系电话：</span><strong>{{ record.b_linkphone }}</strong>
                                    </td>
                                    <td>
                                        <span class="childCss">备注说明：</span><strong>{{ record.b_remark }}</strong>
                                    </td>
                                    <td>
                                        <!-- <template slot="operation" slot-scope="text, record"> -->
                                        <a @click="checkOne(1, record.b_id)" href="javascript:;">抽检</a> |
                                        <a @click="checkOne(2, record.b_id)" href="javascript:;">覆盖</a>
                                        <span v-if="user.role == 1 || user.id == 9983">
                                            |<a @click="checkOne(0, record.b_id)" href="javascript:;">恢复</a>
                                        </span>
                                        <!-- </template> -->
                                    </td>
                                </tr>
                            </table>
                            </p>

                            <template slot="showStatus" slot-scope="text, record">
                                <div :title="text">{{ getStatus(record.b_status) }}</div>
                            </template>
                        </a-table>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
        <!-- 列表表格 -->
    </a-layout-content>
</template>
<script>
import SubTitle from "@/components/common/subTitle";
import { Divider, Modal } from "ant-design-vue";
import { get_check_list, check_invoice, exportData } from "@/api";
import { getUserInfo,materials,depts } from "@/plugins/common";
import moment from "moment";
export default {
    components: {
        SubTitle,
        ADivider: Divider,
        Modal,
    },
    data() {
        return {
            searchText: '',
            searchInput: null,
            searchedColumn: '',
            moment,
            materials,
            depts,
            keyword: "",
            materialName: "",
            deptId:"",
            columns: [/*{
                title: "id",
                width: 50,
                dataIndex: "b_id",
                key: "b_id",
                scopedSlots: { customRender: "showTitle" },
            }, */{
                    title: "供应商名称",
                    width: 150,
                    dataIndex: "a_fullUnitName",
                    rcolumn:"a.fullUnitName",
                    key: "a_fullUnitName",
                    sorter: true,
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'showTitle',
                    }
                },
                {
                    title: "报装编号",
                    width: 100,
                    dataIndex: "a_bzNo",
                    rcolumn:"a.bzNo",
                    key: "a_bzNo",
                    sorter: true,
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'showTitle',
                    }
                },
                {
                    title: "工程项目名称",
                    width: 250,
                    dataIndex: "a_projectName",
                    rcolumn:"a.projectName",
                    key: "a_projectName",
                    sorter: true,
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'showTitle',
                    }
                },
                {
                    title: "物料名称",
                    width: 150,
                    dataIndex: "a_materialName",
                    key: "a_materialName",
                    sorter: true,
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "型号规格",
                    width: 150,
                    dataIndex: "a_model",
                    key: "a_model",
                    sorter: true,
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "数量",
                    width: 70,
                    dataIndex: "a_num",
                    key: "a_num",
                    sorter: true,
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "单位",
                    width: 70,
                    dataIndex: "a_unit",
                    key: "a_unit",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "状态",
                    width: 70,
                    dataIndex: "b_status",
                    key: "b_status",
                    scopedSlots: { customRender: "showStatus" },
                },
                {
                    title: "检测机构",
                    width: 70,
                    dataIndex: "deptName",
                    key: "deptName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "记录人",
                    width: 90,
                    dataIndex: "a_userName",
                    key: "a_userName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "操作",
                    key: "operation",
                    width: 240,
                    scopedSlots: { customRender: "operation" },
                }],
            columns2: [/*{
                title: "id",
                width: 50,
                dataIndex: "b_id",
                key: "b_id",
                scopedSlots: { customRender: "showTitle" },
            }, */{
                    title: "状态",
                    width: 70,
                    dataIndex: "b_status",
                    key: "b_status",
                    scopedSlots: { customRender: "showStatus" },
                }, {
                    title: "供应商名称",
                    width: 150,
                    dataIndex: "a_fullUnitName",
                    rcolumn:"a.fullUnitName",
                    key: "a_fullUnitName",
                    sorter: true,
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'showTitle',
                    }
                },
                {
                    title: "报装编号",
                    width: 100,
                    dataIndex: "a_bzNo",
                    rcolumn: "a.bzNo",
                    key: "a_bzNo",
                    sorter: true,
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'showTitle',
                    }
                },
                {
                    title: "工程项目名称",
                    width: 250,
                    dataIndex: "a_projectName",
                    rcolumn: "a.projectName",
                    key: "a_projectName",
                    sorter: true,
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'showTitle',
                    }
                },
                {
                    title: "物料名称",
                    width: 150,
                    dataIndex: "a_materialName",
                    key: "a_materialName",
                    sorter: true,
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "型号规格",
                    width: 150,
                    dataIndex: "a_model",
                    key: "a_model",
                    sorter: true,
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "数量",
                    width: 70,
                    dataIndex: "a_num",
                    key: "a_num",
                    sorter: true,
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "单位",
                    width: 70,
                    dataIndex: "a_unit",
                    key: "a_unit",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "检测机构",
                    width: 70,
                    dataIndex: "deptName",
                    key: "deptName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "记录人",
                    width: 90,
                    dataIndex: "a_userName",
                    key: "a_userName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "操作时间",
                    width: 120,
                    dataIndex: "b_checked_at",
                    key: "b_checked_at",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "操作",
                    key: "operation",
                    width: 240,
                    scopedSlots: { customRender: "operation" },
                }],
            list: [],
            pagination: {
                total: 0,
                current: 1,
                showTotal: (total) => {
                    return `共 ${total} 条`;
                },
            },
            queryParams: {
                limit: 10,
                page: 0,
                searchCondition: {
                    flag: 0,
                    orderField:'',
                    orderBy:'',
                    assign:1
                },
            },
            loading: false,
            selectTab: '0',
            tabTitle1: "待抽检",
            tabTitle2: "已抽检",

            selectedRowKeys: [],
            expandedRowKeys: [],
            deling: false,

            user: {},
            createValue: [],

        }
    },
    mounted() {
        this.user = getUserInfo();
        this.getList();
        if( this.user.id == 10091 || this.user.id == 10096 ) {
            console.log("change materials");
            this.materials = ["电力电缆", "低压电力电缆"];
        } else {
            this.materials = ["干式变压器", "高压开关柜", "低压开关柜", "电力电缆", "低压电力电缆", "环网柜", "密集母线"];
        }
    },
    methods: {
        searchMe(text){
            this.keyword = text;
            this.getList(true);
        },
        handleSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            this.searchText = selectedKeys[0];
            this.searchedColumn = dataIndex;
            console.log(this.searchText);
            console.log(this.searchedColumn);
            if( !this.queryParams.searchCondition.columns ) {
                this.queryParams.searchCondition.columns = {};
            }
            this.queryParams.searchCondition.columns[this.searchedColumn] = this.searchText;
            this.getList(true);
        },

        handleReset(clearFilters,dataIndex) {
            clearFilters();
            this.searchText = '';
            if( this.queryParams.searchCondition.columns ) {
                delete this.queryParams.searchCondition.columns[dataIndex];
            }
            this.getList(true);
        },
        getList(flag) {
            if (this.loading) return;
            this.loading = true;
            if( flag == true ) {
                this.pagination.current = 1;
            }
            this.queryParams.page = this.pagination.current - 1;

            if (this.keyword) {
                this.queryParams.searchCondition.keyword = this.keyword;
            } else {
                delete this.queryParams.searchCondition.keyword;
            }
            if (this.materialName) {
                this.queryParams.searchCondition.materialName = this.materialName;
            } else {
                delete this.queryParams.searchCondition.materialName;
            }
            if (this.deptId) {
                this.queryParams.searchCondition.deptId = this.deptId;
            } else {
                delete this.queryParams.searchCondition.deptId;
            }
            if (this.selectTab == '12' && this.createValue && this.createValue.length == 2) {
                this.queryParams.searchCondition.btime = moment(this.createValue[0]).format("YYYY-MM-DD HH:mm:ss");
                this.queryParams.searchCondition.etime = moment(this.createValue[1]).format("YYYY-MM-DD HH:mm:ss");
            } else {
                delete this.queryParams.searchCondition.btime;
                delete this.queryParams.searchCondition.etime;
            }
            get_check_list(this.queryParams)
                .then((res) => {
                    console.log(res);
                    this.list = res.list;
                    this.pagination.total = res.total;
                    this.showTabTitle();
                })
                .finally((res) => {
                    this.loading = false;
                });
        },
        onPageChange(pagination, filters, sorter) {
            this.expandedRowKeys = [];
            this.pagination = pagination;
            this.queryParams.page = pagination.current - 1;
            console.log(sorter);
            if( sorter && sorter.field && sorter.order ) {
                let orderField = sorter.field.replace("_",".");
                let orderBy = sorter.order.replace("end","");
                this.queryParams.searchCondition.orderField = orderField;
                this.queryParams.searchCondition.orderBy = orderBy;
            } else {
                delete this.queryParams.searchCondition.orderField;
                delete this.queryParams.searchCondition.orderBy;
            }

            this.getList();
        },
        reset() {// clear conditions
            this.keyword = "";
            this.materialName = "";
            this.deptId = "";
            this.pagination.current = 1;
            this.queryParams.page = 0;
            delete this.queryParams.searchCondition.orderField;
            delete this.queryParams.searchCondition.orderBy;
            delete this.queryParams.searchCondition.columns;
            this.selectedRowKeys = [];
            this.expandedRowKeys = [];
            this.createValue = [];
            this.getList();
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        expandAll() {
            if (this.expandedRowKeys.length == 0) {
                this.list.forEach((item, index) => {
                    this.expandedRowKeys.push(item.b_id);
                });
            } else {
                this.expandedRowKeys = [];
            }
            // console.log(this.expandedRowKeys.length);
        },
        checkMe(status) {
            this.checkInvoice(status, this.selectedRowKeys);
        },
        checkOne(status, id) {
            this.checkInvoice(status, [id]);
        },
        checkInvoice(status, ids) {
            if (!ids || ids.length == 0) {
                this.$message.warning("请选择要操作的数据！");
                return;
            }
            var self = this;
            Modal.confirm({
                title: "提示",
                content: "确定要操作吗？",
                centered: true,
                onOk() {
                    if (self.deling) return;
                    self.deling = true;
                    check_invoice(status, ids)
                        .then((res) => {
                            self.$message.success("操作成功");
                            self.selectedRowKeys = [];
                            self.getList();
                        })
                        .finally((res) => {
                            self.deling = false;
                        });
                },
            });
        },
        rowClass(record) {
            // console.log(record.b_status);
            if (record.b_status == 1) {
                return "checkClass";
            } else if (record.b_status == 2) {
                return "coverClass";
            } else {
                return "";
            }
        },
        getStatus(b_status) {
            if (b_status == 1) {
                return "抽检";
            } else if (b_status == 2) {
                return "覆盖";
            } else {
                return "初始";
            }
        },
        expandMe(expanded, record) {
            console.log(expanded + "~" + record);
            console.log(this.expandedRowKeys);
            if (!expanded) {
                let idx = this.expandedRowKeys.indexOf(record.b_id);
                this.expandedRowKeys.splice(idx, 1);
            } else {
                this.expandedRowKeys.push(record.b_id);
            }
            console.log(this.expandedRowKeys);
        },
        callback(key) {
            this.selectTab = key;
            // console.log(key);
            this.queryParams.searchCondition.flag = key;
            delete this.queryParams.searchCondition.columns;

            this.reset();
        },
        showTabTitle() {
            if (this.selectTab == '0') {
                this.tabTitle1 = "待抽检（" + this.pagination.total + "）";
                this.tabTitle2 = "已抽检";
            } else if (this.selectTab == '12') {
                this.tabTitle1 = "待抽检";
                this.tabTitle2 = "已抽检（" + this.pagination.total + "）";
            }
        },
        MonthOnChange(date, dateString) {
            console.log(date + "\t" + dateString);
            this.createValue = date;
            if (date && date.length) {

            } else {

            }
        },
        exportData() {
            if (this.loading) return;
            this.loading = true;
            this.queryParams.page = this.pagination.current - 1;

            if (this.keyword) {
                this.queryParams.searchCondition.keyword = this.keyword;
            } else {
                delete this.queryParams.searchCondition.keyword;
            }
            if (this.materialName) {
                this.queryParams.searchCondition.materialName = this.materialName;
            } else {
                delete this.queryParams.searchCondition.materialName;
            }
            if (this.deptId) {
                this.queryParams.searchCondition.deptId = this.deptId;
            } else {
                delete this.queryParams.searchCondition.deptId;
            }
            if (this.selectTab == '12' && this.createValue && this.createValue.length == 2) {
                this.queryParams.searchCondition.btime = moment(this.createValue[0]).format("YYYY-MM-DD HH:mm:ss");
                this.queryParams.searchCondition.etime = moment(this.createValue[1]).format("YYYY-MM-DD HH:mm:ss");
            } else {
                delete this.queryParams.searchCondition.btime;
                delete this.queryParams.searchCondition.etime;
            }
            exportData(this.queryParams)
                .then((res) => {
                    console.log(res);
                    window.open(res);
                })
                .finally((res) => {
                    this.loading = false;
                });
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.other-filter {
    display: flex;
    height: 50px;
    align-items: center;

    .mr-20 {
        margin-right: 20px;
    }
}

.childCss {
    font-size: 14px;
}
</style>

<style>
.checkClass {
    color: orange;
}

.coverClass {
    color: blue;
}
</style>